import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiShield, FiCoffee, FiMapPin } = FiIcons;

const TrustSection = () => {
  const guarantees = [
    {
      icon: FiShield,
      title: "Peace of Mind Guarantee",
      description: "If plans change or problems arise, our experts have your back—24/7. We're with you every step of the journey."
    },
    {
      icon: FiCoffee,
      title: "Free, No-Obligation Consultation",
      description: "You pay nothing until you're ready to book. Get expert advice with zero commitment."
    },
    {
      icon: FiMapPin,
      title: "Brick-and-Mortar Support",
      description: "Prefer a face-to-face meeting? Visit our travel boutique in Toronto anytime."
    }
  ];

  return (
    <section className="py-16 relative bg-gradient-to-br from-black to-gray-900">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-6">
          {guarantees.map((guarantee, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              viewport={{ once: true }}
              className="backdrop-blur-xl bg-black/60 rounded-2xl p-6 border border-green-500/30 text-center hover:shadow-xl hover:border-green-400/50 transition-all duration-300"
            >
              <div className="bg-gradient-to-r from-green-500 to-blue-500 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <SafeIcon icon={guarantee.icon} className="text-white text-2xl" />
              </div>
              <h3 className="text-white font-semibold text-xl mb-3">{guarantee.title}</h3>
              <p className="text-gray-300 leading-relaxed">{guarantee.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustSection;